// extracted by mini-css-extract-plugin
export default {"editable":"text_editable__aLiw3"};